module.exports = __webpack_public_path__ + "img/RALLYCROSS.44d0641.jpg";